import { applyDateOverride } from './datePresets';

export function buildViewerExportSpec(
  querySpec = {},
  { botNumber, templateId, dateRange } = {}
) {
  let exportSpec = { ...querySpec };

  if (querySpec.dataset === 'whatsapp_templates') {
    if (botNumber) exportSpec.bot_number = botNumber;
    else delete exportSpec.bot_number;

    if (templateId) exportSpec.template_id = templateId;
    else delete exportSpec.template_id;
  }

  if (dateRange) {
    exportSpec = applyDateOverride(exportSpec, dateRange);
  }

  return exportSpec;
}

export default buildViewerExportSpec;